import React from 'react'

const Textbox = ({ placeholder }) => {
    return (
        <input className='px-8 py-2 rounded-full bg-gray-700' type='textbox' placeholder={placeholder} />
    )
}

export default Textbox